module.exports = __webpack_public_path__ + "static/media/zenodo-authorize.3c5ca132.png";